import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FishersciPricingApiRequestInterface } from '@app/modules/tf-pricing/model/interfaces/fishersci-pricing-api-request.interface';
import { FishersciPricingApiResponseInterface } from '@app/modules/tf-pricing/model/interfaces/fishersci-pricing-api-response.interface';
import { FishersciPricingInterface } from '@app/modules/tf-pricing/model/interfaces/fishersci-pricing.interface';
import { ProductSiteRegionService } from '@app/services/product-site-region.service';
import { map, Observable } from 'rxjs';

@Injectable()
export class FishersciPricingApiService {

    private readonly defaultPricingApi: string = '/taqman/api/v1/price';
    private readonly europeanPricingApi: string = '/taqman/api/v1/price';

    constructor(
        private http: HttpClient,
        private productSiteRegionService: ProductSiteRegionService
    ) {
    }

    getPrice(sku: string, fisherPartNumber?: string): Observable<FishersciPricingInterface> {
        const isEuropeanPricing = this.productSiteRegionService.isFisherSciEurope();
        const payload = isEuropeanPricing
            ? this.getEuropeanPricingPayload(sku, fisherPartNumber)
            : this.getDefaultPricingPayload(sku);

        return this.http.post<FishersciPricingApiResponseInterface>(this.getPricingApi(isEuropeanPricing), payload).pipe(
            map((response: FishersciPricingApiResponseInterface) => {
                return response.payload.parts[0];
            }
        ));

    }

    private getPricingApi(isEuropeanPricing: boolean): string {
        if (isEuropeanPricing) {
            return this.getEuropeanPricingApi();
        }

        return this.defaultPricingApi;
    }

    private getEuropeanPricingApi(): string {
        const countryCode = this.productSiteRegionService.getFisherSciEuropeanCountryCode();

        return `${this.europeanPricingApi}?countryCode=${countryCode}&language=en`;
    }

    private getDefaultPricingPayload(sku: string): FishersciPricingApiRequestInterface {
        return {
            parts: [
                {
                    partNumber: sku,
                    uom: '',
                    manufacturerPart: 'true'
                }
            ],
            callerId: ['magellan']
        };
    }

    private getEuropeanPricingPayload(sku: string, fisherPartNumber?: string): FishersciPricingApiRequestInterface {
        return {
            parts: [
                {
                    partNumber: fisherPartNumber || sku,
                    uom: 'EA',
                    manufacturerPart: 'true',
                }
            ],
            callerId: ['magellan']
        };
    }

}
